import React from "react";

const COLORS = {
    Completed: "#22c55e",
    "In Progress": "#3b82f6",
    Pending: "#f59e0b",
    Overdue: "#ef4444",
};

const WorkStatusOverview = ({ data, onStatusClick }) => {
    const radius = 50;
    const stroke = 14;
    const size = 120;
    const center = size / 2;

    const circumference = 2 * Math.PI * radius;

    // ✅ total
    const total = Object.values(data).reduce((a, b) => a + b, 0);

    // ✅ build segments safely
    let offset = 0;

    const segments = Object.entries(data).map(([key, value]) => {
        const percent = total ? value / total : 0;
        const dash = percent * circumference;

        const seg = {
            key,
            value,
            percent,
            dash,
            offset,
            color: COLORS[key] || "#ccc",
        };

        offset += dash;
        return seg;
    });

    // ✅ filter active segments
    const activeSegments = segments.filter((s) => s.value > 0);

    return (
        <div
            style={{
                display: "flex",
                width: '100%',
                fontFamily: "sans-serif",
                flexWrap: 'wrap',
                alignItems: 'center'
            }}
        >
            {/* ================= CHART ================= */}
            <div style={{ position: "relative", width: size, height: size }}>
                <svg width={size} height={size}>
                    <g transform={`rotate(-90 ${center} ${center})`}>

                        {/* 🔹 Case 1: No data */}
                        {total === 0 && (
                            <circle
                                r={radius}
                                cx={center}
                                cy={center}
                                fill="transparent"
                                stroke="#e5e7eb"
                                strokeWidth={stroke}
                            />
                        )}

                        {/* 🔹 Case 2: Only one segment */}
                        {total > 0 && activeSegments.length === 1 && (
                            <circle
                                r={radius}
                                cx={center}
                                cy={center}
                                fill="transparent"
                                stroke={activeSegments[0].color}
                                strokeWidth={stroke}
                            />
                        )}

                        {/* 🔹 Case 3: Multiple segments */}
                        {activeSegments.length > 1 &&
                            activeSegments.map((seg, i) => (
                                <circle
                                    key={i}
                                    r={radius}
                                    cx={center}
                                    cy={center}
                                    fill="transparent"
                                    stroke={seg.color}
                                    strokeWidth={stroke}
                                    strokeDasharray={`${seg.dash} ${circumference}`}
                                    strokeDashoffset={-seg.offset}
                                    strokeLinecap="butt"
                                />
                            ))}
                    </g>
                </svg>

                {/* 🔹 Center text */}
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                    }}
                >
                    <div style={{ fontSize: 28, fontWeight: "bold", color: '#0f172a' }}>{total}</div>
                    <div style={{ fontSize: 12, color: "#94a3b8" }}>Total</div>
                </div>
            </div>

            {/* ================= LEGEND ================= */}
            <div style={{ marginLeft: 20, width: 210 }}>
                <h4 style={{ marginBottom: 12, color: '#0f172a', fontSize: 13 }}>Work Status</h4>

                {segments.map((seg, i) => (
                    <div
                        key={i}
                        onClick={() => onStatusClick && onStatusClick(seg.key)}
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: 8,
                            fontSize: 12,
                            color: '#475569',
                            cursor: onStatusClick ? 'pointer' : 'default',
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <span
                                style={{
                                    width: 10,
                                    height: 10,
                                    background: seg.color,
                                    borderRadius: 2,
                                }}
                            />
                            {seg.key}
                        </div>

                        <div>
                            {seg.value} ({(seg.percent * 100).toFixed(1)}%)
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default WorkStatusOverview;